// import { debounce } from '@acng/frontend-bounty/timing/debounce.js';
import {debounce} from '@acng/frontend-bounty/timing/debounce.js';
import {laForge} from '../../core/service/env.js';
import {LogEvent} from './events.js';
import {Metric} from './metrics.js';

/**
 * @typedef {Object} ClientOptions
 *
 * @property {string} url - The URL to send log events.
 */

class Client {
  /**
   * @param {ClientOptions} options
   */
  constructor(options) {
    if (!options.url || typeof options.url !== 'string') {
      throw new Error('No url given');
    }

    /**
     * @type {Metric[]}
     */
    this.buffer = [];
    this.debuncedSend = debounce(this.sendBuffer.bind(this), 5000);
    this.config = {
      url: options.url,
    };

    window.addEventListener('beforeunload', () => this.sendBuffer());
  }

  sendBuffer() {
    if (!this.buffer.length) return;
    const data = this.buffer;
    this.buffer = [];
    const blob = new Blob([JSON.stringify(data)], {
      type: 'application/json',
    });
    navigator.sendBeacon(this.config.url + '/metrics', blob);
  }

  /**
   * @param {LogEvent | import('./events').LogEventDTO} data
   */
  send(data) {
    if (data instanceof LogEvent) {
      data = data.getDTO();
    }
    const blob = new Blob([JSON.stringify(data)], {
      type: 'application/json',
    });

    navigator.sendBeacon(this.config.url + '/event', blob);
  }

  /**
   * @param {Metric} metric
   */
  metrics(metric) {
    this.buffer.push(metric);
    this.debuncedSend();
  }

  /**
   * @param {LogEvent} event
   */
  log(event) {
    if (!(event instanceof LogEvent)) {
      throw new Error('No Log Event given');
    }

    this.send(event.getDTO());
  }
}

/**
 * @type {Client}
 */
export const logger = new Client({
  url: laForge,
});
